'use client';

import { useEffect, useRef, useState } from 'react';

import throttle from 'lodash.throttle';

import ContentsLinks from '../ContentsLinks/ContentsLinks';

const SECTION_IDS = ['overall', 'inside', 'driving', 'running-cost', 'versions'];

interface ContentsLinksBarProps {
  hasFaqs: boolean;
  strings: Record<string, string>;
}

export const ContentsLinksBar = ({ hasFaqs, strings }: ContentsLinksBarProps) => {
  const [activeSection, setActiveSection] = useState<string | undefined>('overall');
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const allIds = hasFaqs ? [...SECTION_IDS, 'questions'] : SECTION_IDS;

    const handleScroll = throttle(() => {
      if (!ref.current) return;
      const navBottom = ref.current.getBoundingClientRect().bottom;

      for (const id of allIds) {
        const el = document.getElementById(id);
        if (!el) continue;
        const { top, bottom } = el.getBoundingClientRect();
        if (navBottom >= top && navBottom < bottom) {
          setActiveSection(id);
          return;
        }
      }
    }, 100);

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
      handleScroll.cancel();
    };
  }, [hasFaqs]);

  return (
    <ContentsLinks
      ref={ref}
      activeSectionId={activeSection}
      hasCommonQuestions={hasFaqs}
      strings={strings}
    />
  );
};
